import {createContext} from 'react'

export const FloatingContext = createContext({})
